import { Placeholder } from 'types/step';

function slugify(text: string): string {
  return text
    .toString()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
}

export type FormDefinition = (Placeholder & { slug: string })[];

export default function getFormDefinition(
  placeholders: Placeholder[]
): FormDefinition {
  return placeholders.map((placeholder) => ({
    ...placeholder,
    slug: slugify(placeholder.placeholderKey),
  }));
}

export function getInitialValues(
  formDefinition: FormDefinition,
  filledData: Record<string, any>
): Record<string, any> {
  return formDefinition.reduce((acc, placeholder) => {
    const stringValue = filledData[placeholder.placeholderKey] || '';

    switch (placeholder.type) {
      case 'boolean':
        acc[placeholder.slug] = stringValue === 'true';
        break;
      case 'multidate':
        acc[placeholder.slug] = stringValue;
        break;
      case 'dateTextList':
        try {
          const parsed =
            stringValue && stringValue !== '[]' ? JSON.parse(stringValue) : [];
          acc[placeholder.slug] = Array.isArray(parsed) ? parsed : [];
        } catch {
          acc[placeholder.slug] = [];
        }
        break;
      case 'number':
      case 'float':
      case 'date':
      default:
        acc[placeholder.slug] = stringValue;
        break;
    }

    return acc;
  }, {});
}

export function getFilledData(
  formDefinition: FormDefinition,
  values: Record<string, any>
): Record<string, any> {
  return formDefinition.reduce((acc, placeholder) => {
    let value = String(values[placeholder.slug] || '');

    if (placeholder.type === 'multidate') {
      value = value
        .split(' | ')
        .map((d) => d.trim())
        .filter((d) => d)
        .join(' | ');
    } else if (placeholder.type === 'dateTextList') {
      const arrayValue = Array.isArray(values[placeholder.slug])
        ? values[placeholder.slug]
        : [];
      value = JSON.stringify(arrayValue);
    }

    acc[placeholder.placeholderKey] = value;
    return acc;
  }, {});
}
